import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import CreateEntitiesEditor from '../editors/custom-editors/CreateEntitiesEditor';
import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';
import {CUSTOM_COMPONENT_KEY, FIELD_ORDER_UI_SCHEMA_KEY} from '../StepConfigEditorTypes';

export const CREATE_ENTITIES_V0_UI_SCHEMA: StepTypeConfigUISchemaV2<PipelineStepType.CREATE_ENTITIES, 0> = {
  [FIELD_ORDER_UI_SCHEMA_KEY]: ['schemaId'],
  schemaId: {
    [FIELD_ORDER_UI_SCHEMA_KEY]: ['schemaId'],
    schemaId: {
      [CUSTOM_COMPONENT_KEY]: CreateEntitiesEditor,
    },
  },
};
